module.exports = __webpack_public_path__ + "img/marker-primary.svg?a654a8c20c79c7ad37733789c7d19d38";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maps/marker-primary.svg
// module id = 296
// module chunks = 0